<template>
    <b-form-datepicker
        v-model="dateParam"
        placeholder=""
        :locale="locale"
        @input="changeDate">
    </b-form-datepicker>
</template>

<script>

export default {
    props: [
        'locale',
        'date',
        'endpoint'
    ],

    data() {
        return {
            dateParam: this.date
        }
    },

    created() {
        this.$moment.locale(this.locale)
    },

    methods: {

        changeDate(event) {
            window.location = this.endpoint + '?date=' + event
        }

    }
}
</script>

<style>

</style>
